export enum AuthError {
    AUTH_001 = "INVALID_LOGIN",
    AUTH_002 = "SIGNATURE_EXPIRED",
    AUTH_003 = "INCORRECT_PASSWORD",
    AUTH_004 = "DUPLICATE_PASSWORD"
}